import { useTheme } from 'foundations-theming/utils';
import { createCssVarsFromTheme } from 'foundations-theming/utils/createCssVars';
import { createGlobalStyle } from 'styled-components';
import { FLASH_TOKENS_STORAGE_KEY } from 'foundations-theming/components/ThemeProvider/ThemeProvider.helpers';
export const APPLIED_CSS_VARS_FLAG = '--css-vars-applied';
const LOCAL_CSS_VARS_KEY = 'trellis:local-dev-only-use-css-variables';
const safeLocalStorageGet = key => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};
export const GlobalCSSVariables = createGlobalStyle(() => {
  const theme = useTheme();
  const isLocalCssVars = safeLocalStorageGet(LOCAL_CSS_VARS_KEY) === 'true';
  const isFlashing = safeLocalStorageGet(FLASH_TOKENS_STORAGE_KEY) === 'true';
  const baseStyles = {};
  const themeForCssVars = isLocalCssVars && theme.theme ? theme.theme : theme;
  const cssVars = createCssVarsFromTheme(themeForCssVars);
  const rootStyles = Object.assign({}, cssVars, {
    [APPLIED_CSS_VARS_FLAG]: 'true'
  });

  // Adds flashing animation styles if the "flash unsafe tokens"
  // local storage flag has been set. Used only in local dev.
  // https://git.hubteam.com/HubSpot/foundations-components/pull/6203
  if (isFlashing) {
    baseStyles['@keyframes trellis-flash-animation'] = {
      '0%, 100%': {
        '--trellis-flash-token': '#BCFF2B'
      },
      '50%': {
        '--trellis-flash-token': '#000000'
      }
    };
    Object.assign(rootStyles, {
      '--trellis-flash-token': '#BCFF2B',
      animation: 'trellis-flash-animation 1s infinite'
    });
  }
  return Object.assign({}, baseStyles, {
    ':root': rootStyles
  });
});